<template>
	<div class="container-fluid" data-config-step="2">
		<!-- steps-->
		<!-- step-2-budget -->
		<div class="row">
			<div class="budget-selection">
				<!-- loader -->
				<div v-if="isLoading" class="loading">
					<p class="front">CALCULATING</p>
					<div class="overlay-bg"/>
				</div>
				<!-- /loader -->
				<div class="columns-container container-fluid pos-r">
					<h1 class="step2-heading">
						Pick your price
					</h1>
					<hr>
					<!-- <games-performance :games="selectedGames" :resolution-text="resolutionText" /> -->
					<div class="system-requirements-container col-xs-12 col-md-6">
						<hr class="budget-separator budget-separator-ipad">
						<game-fps-list
							:games="selectedGames"
							:resolution-text="resolutionText"
							only-recommended-fps
						/>
					</div>
					<!-- budget-select -->
					<div v-if="!CONSTANTS.COVID_19" class="budget-container col-xs-12 col-md-6">
						<!-- price-select -->
						<div class="select-budget">
							<div class="text-wrapper-mid text-white">
								<h4 class="text-bold text-uppercase">Build your own</h4>
							</div>
							<div class="select-budget">
								<a id="price1" class="btn btn-green btn-outline set-price" @click="setPrice(1000)">
									<sup>$</sup>1000
									<span class="currency-code">USD</span>
								</a>
								<a id="price2" class="btn btn-green btn-outline set-price" @click="setPrice(1500)">
									<sup>$</sup>1500
									<span class="currency-code">USD</span>
								</a>
								<a id="price3" class="btn btn-green btn-outline set-price" @click="setPrice(2000)">
									<sup>$</sup>2000
									<span class="currency-code">USD</span>
								</a>
								<a id="price4" class="btn btn-green btn-outline set-price" @click="setPrice(2500)">
									<sup>$</sup>2500
									<span class="currency-code">USD</span>
								</a>
							</div>
							<hr class="budget-separator">
							<div class="pre-built-budget-text text-wrapper-mid text-white">
								<h4 class="text-bold text-uppercase">Pre-built</h4>
							</div>
							<div class="pre-built-budget-container">
								<a
									@click.prevent="goToStarterPc()"
									href="#"
									id="price4"
									class="btn btn-green btn-outline set-price"
								>
									<span class="pre-built-price">
										<small>From</small><sup>$</sup>699
										<span class="currency-code">USD</span>
									</span>
									<span class="pre-built-title">
										{{ CONSTANTS.STARTERPCSERIES.TITLE }}
									</span>
								</a>
								<a
									@click.prevent="goToStreamerPc()"
									href="#"
									id="price5"
									class="btn btn-green btn-outline set-price"
								>
									<span class="pre-built-price">
										<sup>$</sup>1499
										<span class="currency-code">USD</span>
									</span>
									<span class="pre-built-title">
										{{ CONSTANTS.STREAMERPC.TITLE }}
									</span>
								</a>
								<a
									@click.prevent="goToH1MiniPc()"
									href="#"
									id="price6"
									class="btn btn-green btn-outline set-price"
								>
									<span class="pre-built-price">
										<sup>$</sup>1999
										<span class="currency-code">USD</span>
									</span>
									<span class="pre-built-title">
										{{ CONSTANTS.H1MINIPC.TITLE }}
									</span>
								</a>
							</div>
						</div>
						<!-- /.price-select -->
					</div>

					<div v-else class="budget-container col-xs-12 col-md-6 coronavirus-budget">
						<!-- price-select -->
						<div class="select-budget">
							<div class="text-wrapper-mid text-white">
								<h4 class="text-bold text-uppercase">Pre-Built</h4>
							</div>
							<div class="select-budget">
								<a
									@click.prevent="goToStarterPc()"
									href="#"
									id="price4"
									class="btn btn-green btn-outline set-price"
								>
									<span class="pre-built-price">
										<sup>$</sup>899<span class="currency-code">USD</span>
									</span>
									<span class="pre-built-title">
										{{ CONSTANTS.STARTERPC.TITLE }}
									</span>
								</a>
								<a
									@click.prevent="goToStreamerPc()"
									href="#"
									id="price5"
									class="btn btn-green btn-outline set-price"
								>
									<span class="pre-built-price">
										<sup>$</sup>1499
										<span class="currency-code">USD</span>
									</span>
									<span class="pre-built-title">
										{{ CONSTANTS.STREAMERPC.TITLE }}
									</span>
								</a>
								<a
									@click.prevent="goToH1MiniPc()"
									href="#"
									id="price6"
									class="btn btn-green btn-outline set-price"
								>
									<span class="pre-built-price">
										<sup>$</sup>1999
										<span class="currency-code">USD</span>
									</span>
									<span class="pre-built-title">
										{{ CONSTANTS.H1MINIPC.TITLE }}
									</span>
								</a>
							</div>
							<hr class="budget-separator">
							<div class="pre-built-budget-text text-wrapper-mid text-white">
								<h4 class="text-bold text-uppercase coronavirus-budget__build-heading">Build Your Own</h4>
							</div>
							<p class="coronavirus-budget__warning">
								<img src="/images/icons/question-help.svg">
								Due to COVID-19, our custom PC build service is currently unavailable. Fear not! BLD prebuilds are still available.
							</p>
							<div class="pre-built-budget-container">
								<a id="price1" class="btn btn-green btn-outline set-price" @click="setPrice(1000)">
									<sup>$</sup>1000<span class="currency-code">USD</span>
								</a>
								<a id="price2" class="btn btn-green btn-outline set-price" @click="setPrice(1500)">
									<sup>$</sup>1500<span class="currency-code">USD</span>
								</a>
								<a id="price3" class="btn btn-green btn-outline set-price" @click="setPrice(2000)">
									<sup>$</sup>2000<span class="currency-code">USD</span>
								</a>
								<a id="price4" class="btn btn-green btn-outline set-price" @click="setPrice(2500)">
									<sup>$</sup>2500<span class="currency-code">USD</span>
								</a>
							</div>
						</div>
						<!-- /.price-select -->
					</div>
					<a
						alt="Back"
						title="Back"
						href="/bld"
						class="back-step visible-lg visible-md"
					>
						<i aria-hidden="true" class="back-step-ico">
							<img src="/images/icons/back-ico.svg" alt="" width="30">
						</i>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import GameFpsList from "./game-fps-list";
import CONSTANTS from "@/config/constants";
import { heapAnalytics } from "@/util/mixins";
import { gtmTrack } from "@/util/gtm";

export default {
	name: "Step2",
	components: {
		GameFpsList
	},
	mixins: [heapAnalytics],
	data() {
		return {
			CONSTANTS,
			isLoading: "true",
			recommendedBuilds: [],
			resolutionText: "",
			selectedGames: [],
			selectedPrice: 0
		};
	},
	created() {
		this.getSelectedGames();
	},
	methods: {
		getSelectedGames() {
			axios({
				url: `/store/bld/steps/2&session=${CONFIG.SESSION}`,
				method: "GET",
				responseType: "json"
			}).then(response => {
				if (!response.data.games.length) {
					this.$router.push({ name: "step1" });
					toastr.warning("You should select at least one game", "No games selected");
					return;
				}
				this.selectedGames = response.data.games;
				this.resolutionText = response.data.resolutionText;
				this.isLoading = false;
			}).catch(error => {
				if (error.response.data && error.response.data.status.message == "No games have been selected.") {
					toastr.warning("You should select at least one game", "No games selected");
					this.$router.replace({ name: "step1" });
				}
			});
		},
		goToStarterPc() {
			// TO-DO: Remove the hasSelectedGames when API have a way to check if games have changed
			const hasSelectedGames = (this.selectedGames.length > 0);
			this.trackAll("Client: Click SP Price Band");
			this.trackAll("Client: Click Price Band", { Band: 699 });
			this.$router.push({ name: "starter-series", params: { hasSelectedGames } });
		},
		goToStreamerPc() {
			this.trackAll("Client: Click Streaming PC Price Band");
			this.trackAll("Client: Click Price Band", { Band: 1499 });
			this.$router.push({ name: "streaming-pc" });
		},
		goToH1MiniPc() {
			this.trackAll("Client: Click H1 MINI PC Price Band");
			this.trackAll("Client: Click Price Band", { Band: 1999 });
			this.$router.push({ name: "h1-mini-pc" });
		},
		goToStep3() {
			this.$router.push({
				name: "step3",
				query: {
					price: this.selectedPrice
				}
			});
		},
		removeGame(gameIndex, gameId) {
			axios({
				url: `/remove-game/${gameId}`,
				method: "GET",
				headers: {
					"token": CONFIG.SESSION
				}
			});

			this.selectedGames.splice(gameIndex, 1);

			if (!this.selectedGames.length) {
				this.$router.push({
					name: "step1"
				});
			}
		},
		setPrice(price) {
			this.selectedPrice = price;
			this.trackAll("Client: Click Price Band", { Band: price });
			gtmTrack.configuratorBudget(price);
			this.goToStep3();
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.currency-code {
    font-size: 14px;
    font-weight: 200;
    color: rgba($color: #fafafa, $alpha: .6);
    margin-bottom: -10px;
    position: relative;
    margin-left: 2px;
}

.budget-container, .system-requirements-container {
    @media (max-width: 991px)  {
        padding: 0;
    }
}

.system-requirements-container {
    @media (min-width: 992px) and  (max-width: 1024px) {
        margin-top: 12px;
    }
    @media (min-width: 1025px) {
        margin-top: 13px;
    }
}

.step2-heading {
    margin: 15px 0;
    color: #FFFFFF;
    font-family: Akkurat-Light;
    font-size: 24px;
    font-weight: 300;
    text-align: center;
}

[data-config-step="2"] {
    hr {
        margin: 0;
        opacity: 0.15;
    }

    .step2-heading, hr {
        display: none;

        @media (max-width: 991px)  {
            display: block;
        }
    }
}

.budget-separator {
    margin-top: 30px;
}


.budget-container, .pre-built-budget-container {
    .set-price {
        color: $white !important;

        &:hover {
            color: $white !important;
        }
    }
}

.pre-built-budget-container {
    display: flex;

    @media (max-width: 767px)  {
        display: block;
    }

    .set-price {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: 0 0 15px 0;

        @media (max-width: 767px)  {
            flex-direction: row-reverse;
            justify-content: space-between;
        }

        .pre-built-title {
            color: $white;
            font-size: 14px;
            letter-spacing: 1.75px;
            font-weight: bold;
            text-transform: uppercase;
            transition: all .3s;
            margin-top: 5px;

            @media (max-width: 767px)  {
                font-size: 12px;
                margin-top: 0;
                max-width: 130px;
                white-space: initial;
                text-align: left;
            }
        }

        .pre-built-price {
            font-size: 32px;

            small {
                font-size: 14px;
                letter-spacing: initial;
                text-transform: none;
                margin-right: 3px;
            }

            .currency-code {
                margin-left: -8px;
            }

            @media (max-width: 767px)  {
                font-size: 38px;
            }
        }
    }

    .set-price:not(:last-child) {
        margin-right: 15px;
    }
}

@media (max-width: 991px) {
    .nzxtcustom {
        padding-top: 60px !important;
    }

    .budget-selection {
        .select-budget {
            .btn {
                font-size: 38px;
            }

        }
        .text-wrapper-mid {
            h4 {
                font-size: 20px;
            }
        }

        .pre-built-budget-text {
            h4 {
                margin-bottom: 15px;;
            }
        }
    }

    .columns-container {
        display: flex;
        flex-direction: column;

        .budget-container {
            order: 1;
            .text-wrapper-mid {
                margin: 20px 0 5px;
            }
        }

        .system-requirements-container {
            margin-bottom: 60px;
            order: 2;

            .text-wrapper-mid {
                margin-top: 0;
                margin-bottom: 20px;
            }
        }
    }
}

.coronavirus-budget {
    .select-budget {
        .set-price {
            display: flex;
            flex-direction: column;

            @media (max-width: 767px)  {
                flex-direction: row-reverse;
                justify-content: space-between;
            }

            .pre-built-price {
                display: flex;
                align-items: center;
            }

            .pre-built-title {
                font-size: 14px;
                font-weight: bold;
                letter-spacing: 1.75px;
            }
        }
    }

    .pre-built-budget-container {
        .set-price {
            display: flex;
            flex-direction: row;

            @media (max-width: 767px) {
                justify-content: center;
            }
        }
    }

    &__build-heading {
        @media (max-width: 767px) {
            margin-bottom: 0 !important;
        }
    }

    &__warning {
        color: #FFFFFF;
        font-family: Akkurat-Light;
        font-size: 16px;
        font-weight: 300;
        letter-spacing: 0.95px;
        line-height: 26px;
        margin-bottom: 25px;

        @media (max-width: 767px)  {
            font-family: 'Akkurat-Normal';
            font-size: 14px;
            letter-spacing: 0;
            line-height: 19px;
            margin-bottom: 15px;
        }

        img {
            height: 15px;
        }
    }
}

@media only screen
and (min-device-width : 768px)
and (max-device-width : 1024px)
and (orientation : portrait) {
    .budget-separator-ipad {
        margin: 15px 0 !important;
    }
}
</style>
